import { elIds, uiClasses } from './ui-constants';

export default function injectApplePayCss(): void {
  if (document.getElementById(elIds.stylesheet_id) !== null) {
    return;
  }
  const spinnerStyleEl = document.createElement('style');
  spinnerStyleEl.id = elIds.stylesheet_id;
  const cssText = document.createTextNode(`
    .${uiClasses.whitePanel} {
      background-color: #fff;
      border-radius: 20px;
      padding: 60px 30px;
      box-shadow: 0 3px 10px 0 rgba(0,0,0,0.2);
      max-width: 350px;;
    }

    .${uiClasses.paymentAmount} {
      font-size: 1.4rem;
      font-weight: normal;
      margin: 25px 0 20px;
    }

    .${uiClasses.applePayButton} {
      display: inline-block;
      -webkit-appearance: -apple-pay-button;
      -apple-pay-button-type: buy;
      -apple-pay-button-style: black;
      text-indent: -1000em;
      border-radius: 4px;
      height: 50px;
      width: 92%;
      max-width: 300px;
      background-color: black;
      cursor: pointer;
      margin: 3em 0 1em 0;
    }

    .${uiClasses.instructionalText} {
      font-size: 1.4rem;
      font-weight: 700;
      color: #3D444C;
    }
    .${uiClasses.subText} {
      color: #ccc;
    }
    .${uiClasses.iconContainer} svg {
      transform: scale(1.4);

    }
  `);
  spinnerStyleEl.appendChild(cssText);
  document.head.appendChild(spinnerStyleEl);
}
